var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35464 11.6327L5.07201 11.5714C4.00914 11.5501 2.94366 11.5927 1.90168 11.3715C0.316517 11.0411 0.204224 9.42087 0.0867073 8.06181C-0.0752042 6.15113 -0.0125288 4.20581 0.293014 2.31112C0.465371 1.24786 1.14435 0.613627 2.19417 0.544341C5.73794 0.293848 9.30522 0.323161 12.8412 0.440413C13.2146 0.451073 13.5906 0.509699 13.9589 0.576319C15.7765 0.901428 15.8208 2.73749 15.9384 4.28309C16.0559 5.84468 16.0063 7.41426 15.7817 8.96519C15.6015 10.2496 15.2568 11.3262 13.8022 11.4301C11.9794 11.5661 10.1983 11.6753 8.37031 11.6407C8.37031 11.6327 8.35986 11.6327 8.35464 11.6327ZM6.42476 8.38159C7.79839 7.57681 9.14592 6.78536 10.5117 5.98591C9.13547 5.18114 7.79056 4.38968 6.42476 3.59024V8.38159Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ef349d191e5a9ff827efef8c5fa40182.svg";
export { ForwardRef as ReactComponent };